import {
    Autocomplete, Box, Button, Checkbox, FormControlLabel,
    Grid, InputAdornment, Paper, Stack, TextField, Tooltip
} from '@mui/material'
import React, { useEffect } from 'react'
import { Colors } from '../../../Styles/Colors'
import CommonGridHeader, { CommonEditButton } from '../../../Components/Common Components/CommonComponents';
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import { localGetItem } from '../../../Utility/Services/CacheProviderService';
import { ImagePaths } from '../../../Utility/ImagePaths';

function PharmaDoctorList(props) {
    const [docDetails, setDocDetails] = React.useState([]);
    const [current_page, setCurrent_page] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [isLoader, setIsLoader] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(false);
    const [spcInfo, setSpcInfo] = React.useState([]);
    const [successMsg, setSuccessMsg] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState(false);
    const [successMsgText, setSuccessMsgText] = React.useState("");
    const [errorMsgText, setErrorMsgText] = React.useState("");
    const [doctorName, setDoctorName] = React.useState("");
    const [specName, setSpecName] = React.useState(null);
    const [qualification, setQualification] = React.useState("");
    const [regNo, setRegNo] = React.useState("");
    const [isActive, setIsActive] = React.useState(true);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [docID, setDocID] = React.useState(null);

    const { t } = props;
    const myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    const pharmacy_type = myUser?.pharmacy_type === 'Inhouse Pharmacy' ? "Pharmacy" : "Standalone Pharmacy";

    useEffect(() => {
        getSpecInfo();
        getDoclist();
    }, [])

    const errorMessage = (msg) => {
        setErrorMsg(true);
        setErrorMsgText(msg);
    }

    const successMessage = (msg) => {
        setSuccessMsg(true);
        setSuccessMsgText(msg);
    }
    const getDoclist = () => {
        try {
            setIsLoader(true)
            RestAPIService.getAll(`${Serviceurls.PHARMA_EXTERNAL_DOCTOR}`)
                .then(response => {
                    if (response.data.status === "success") {
                        setDocDetails(response.data.data)
                        setIsLoader(false)
                    }
                })
                .catch(error => {
                    errorMessage(error?.response?.data?.message || error.message);
                    setIsLoader(false)
                });
        } catch (e) {
            setIsLoader(false)
            errorMessage(e.message);
        }
    }

    const getSpecInfo = () => {
        setSpcInfo([])
        try {
            setIsLoader(true)
            RestAPIService.getAll(`${Serviceurls.FO_CONFIG_OPSPECIALIZATION}?clinic_id=${myUser?.clinic_id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let datas = response.data.data
                        setSpcInfo(datas.filter(item => item.is_active === true))
                        setIsLoader(false)
                    }
                })
                .catch(error => {
                    errorMessage(error?.response?.data?.message || error.message);
                    setIsLoader(false)
                });
        } catch (e) {
            setIsLoader(false)
            errorMessage(e.message, false);
        }
    }
    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value.trimStart();
        let isValid = false;
        switch (name) {
            case "regNo":
                const partialRegNoRegex = /^[A-Z0-9/-]*$/i;
                if ((value === "" || partialRegNoRegex.test(value)) && value.length <= 20) {
                    setRegNo(value);
                }
                break;
            case "doctorName":
                isValid = CommonValidation.alphabetOnly(value);
                if (value === "" || isValid && value.length <= 50) {
                    setDoctorName(value);
                }
                break;
            case "qualification":
                const regex = /^[a-zA-Z\s().]*$/;
                if ((value === "" || regex.test(value)) && value.length <= 50) {
                    setQualification(value);
                }
                break;
            default:
                isValid = CommonValidation.alphabetOnly(value);
                if (value === "" || isValid) {
                    setSpecName(value);
                }
                break;
        }
    }
    const renderTextBox = (label, statekey, value, width) => {
        const { t } = props;
        const defaultdata = [{ name: 'No options Found' }]
        return (
            <Box id="eMed_srvConfig_divs">
                {
                    statekey === "specName" ?
                        <Autocomplete
                            disableClearable
                            value={value ? value : ""}
                            sx={{ width: width ? width : "14vw" }}
                            size="small"
                            options={spcInfo.length != 0 ? spcInfo : defaultdata}
                            getOptionLabel={option => typeof (option) === "string" ? option : option.name}
                            onChange={(event, newSpec) => {
                                setSpecName(newSpec)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t(label)}
                                    InputProps={{
                                        ...params.InputProps,
                                    }}
                                />
                            )}
                        />
                        :
                        <TextField
                            sx={{ width: width ? width : "14vw" }}
                            autoComplete="off"
                            required={statekey === "doctorName" || statekey === "qualification"}
                            disabled={isEdit && label === "DoctorName" ? true : false}
                            size="small"
                            label={t(label)}
                            name={statekey}
                            value={value ? value : ""}
                            onChange={(e) => handleChange(e)}
                            InputProps={{
                                startAdornment: statekey === "doctorName" ? <InputAdornment position="start">{'Dr'}</InputAdornment> : false
                            }}
                        />
                }
            </Box>
        )
    }
    const handleSave = () => {
        if (isSubmitting) return;
        if (doctorName === "") {
            errorMessage("Please enter Doctor Name");
        } else if (qualification === "") {
            errorMessage("Please enter Qualification");
        } else {
            try {
                setIsSubmitting(true);
                let saveData = {
                    "doctor_name": doctorName || '',
                    "specialization": specName?.name || '',
                    "qualification": qualification || '',
                    "reg_no": regNo || '',
                    "is_active": isActive
                }
                if (isEdit) { saveData['doctor_id'] = docID }
                setIsLoader(true)
                RestAPIService.create(saveData, `${Serviceurls.PHARMA_EXTERNAL_DOCTOR}`)
                    .then(response => {
                        if (response.data.status === "success") {
                            successMessage(response.data.message);
                            handleClear();
                            getDoclist();
                        }
                        setIsLoader(false)
                        setIsSubmitting(false);
                    })
                    .catch(error => {
                        errorMessage(error?.response?.data?.message || error.message);
                        setIsLoader(false)
                        setIsSubmitting(false);
                    });
            } catch (e) {
                setIsLoader(false)
                errorMessage(e.message);
                setIsSubmitting(false);
            }
        }
    }

    const handleClear = () => {
        setIsLoader(false)
        setIsEdit(false)
        setDoctorName("")
        setSpecName(null)
        setQualification("")
        setRegNo("")
        setIsActive(true)
        setIsSubmitting(false);
    }

    const msgClose = () => {
        setSuccessMsg(false);
        setErrorMsg(false);
        setSuccessMsgText("");
        setErrorMsgText("");
    }

    const handleEdit = (data) => {
        setIsEdit(true)
        setDoctorName(data?.doctor_name)
        setSpecName(data?.specialization ? { name: data?.specialization } : null)
        setQualification(data?.qualification)
        setRegNo(data?.reg_no)
        setIsActive(data?.is_active)
        setDocID(data.id)
    }
    docDetails?.forEach((element, index) => element.sno = index + 1)
    const columns = [

        { field: 'sno', headerName: 'S.No', sortable: false, flex: 0.05, },
        {
            field: 'doctor_name', headerName: t('DoctorName'), flex: 0.25, renderCell: (params) => {
                const name = params?.row?.doctor_name || '';
                const displayName = name.length > 20 ? name.slice(0, 20) + '...' : name;
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        {name.length > 20 ? (
                            <Tooltip placement="top" title={name} arrow>
                                <div>{'Dr ' + displayName}</div>
                            </Tooltip>
                        ) : (
                            <div>{'Dr ' + displayName}</div>
                        )}
                        {params?.row?.is_active === false && (
                            <Tooltip title="Inactive Doctor" arrow>
                                <img
                                    src={ImagePaths.Red.default}
                                    alt="inactive"
                                    style={{ width: '.6vw', height: '.6vw' }}
                                />
                            </Tooltip>
                        )}
                    </div>
                );
            }
        },
        {
            field: 'qualification', headerName: t('Qulaification'), flex: 0.20, renderCell: (params) => {
                return (
                    <div>{params?.row?.qualification?.length > 15 ? <Tooltip placement="top" title={params?.row?.qualification} arrow><div>{params?.row?.qualification.slice(0, 15) + "..."}</div></Tooltip> : params?.row?.qualification}</div>
                )
            }
        },
        {
            field: 'reg_no', headerName: t('Registration No'), flex: 0.20, renderCell: (params) => {
                return (
                    <div>{params?.row?.reg_no?.length > 15 ? <Tooltip placement="top" title={params?.row?.reg_no} arrow><div>{params?.row?.reg_no.slice(0, 15) + "..."}</div></Tooltip> : params?.row?.reg_no}</div>
                )
            }
        },
        {
            field: 'specialization', headerName: t('Specialization'), flex: 0.20, renderCell: (params) => {
                return (
                    <div>{params?.row?.specialization?.length > 15 ? <Tooltip placement="top" title={params?.row?.specialization} arrow><div>{params?.row?.specialization.slice(0, 15) + "..."}</div></Tooltip> : params?.row?.specialization}</div>
                )
            }
        },
        {
            field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.10, sortable: false, hideable: false, align: "center", renderCell: (params) => {
                return (
                    <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                        <CommonEditButton disable={!CheckAccessFunc(pharmacy_type, "Settings", "External Doctor List", null, "SubTab")?.editAccess} size="1.5vw" onClick={handleEdit.bind(this, params.row)} />
                    </Stack>
                )
            }
        }
    ]
    return (
        <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
            <Grid container spacing={3} className="eMed_srvConfig_Box">
                <Grid item xs={7.6}>
                    <Paper sx={{ height: '76vh' }}>
                        <DataGrid
                            rows={docDetails}
                            columns={columns}
                            getRowId={(row) => row.id}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            disableRowSelectionOnClick
                            components={{
                                Toolbar: CommonGridHeader.CommonToolBar,
                                NoRowsOverlay: () => {
                                    return (
                                        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                            {t("NoRecordsFound")}
                                        </Stack>
                                    )
                                }
                            }}
                            headerHeight={40}
                            rowCount={docDetails.length}
                            pageSizeOptions={[10, 20, 30]}
                            pagination
                            paginationMode="client"
                            paginationModel={{
                                page: current_page,
                                pageSize: rowsPerPage
                            }}
                            onPaginationModelChange={(model) => {
                                setCurrent_page(model.page)
                                setRowsPerPage(model.pageSize)
                            }}
                            loading={isLoader}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={4.4}>
                    <Paper sx={{ height: '74vh' }}>
                        <Box className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                            <p className='eMed_srvConfig_rightHead_txt'>{t('DoctorConfiguration')}</p>
                        </Box>
                        <Box className="eMed_srvConfig_subDiv" marginTop={'1vw'}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                {renderTextBox('DoctorName', "doctorName", doctorName)}
                                {renderTextBox('Specialization', "specName", specName)}
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                {renderTextBox('Qualification', "qualification", qualification)}
                                {renderTextBox('RegistrationNo', "regNo", regNo)}
                            </Stack>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                {<Box sx={{ width: "14vw" }}>
                                    <FormControlLabel label="Active" labelPlacement="start" sx={{ gap: '1vw' }} control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} />} />
                                </Box>}
                            </Stack>
                        </Box>
                        <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                            <Button variant='outlined' emed_tid="doctor_config_clear_btn" size="small" id="eMed_Config_btn" onClick={() => { handleClear() }}>{t("Clear")}</Button>
                            <Button variant='contained' emed_tid="doctor_config_save_btn" disabled={!CheckAccessFunc(pharmacy_type, "Settings", "External Doctor List", null, "SubTab")?.editAccess || isSubmitting} size="small" id="eMed_Config_btn"
                                onClick={() => { handleSave() }}>{t("Save")}</Button>
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>
            {
                successMsg ?
                    <ToastMsg
                        severity={"success"}
                        msg={successMsgText}
                        msgPop={msgClose.bind(this)} /> : null
            }
            {
                errorMsg ?
                    <ToastMsg
                        severity={"error"}
                        msg={errorMsgText}
                        msgPop={msgClose.bind(this)} /> : null
            }
        </Box>
    )
}
export default withTranslation()(PharmaDoctorList);